(function () {
  'use strict';

  // Fator de preço por região vem da colmeia-api, resolvido pelo IP da
  // requisição (MaxMind) sem geolocalização do navegador. Enquanto não
  // resolve, preço fica em skeleton (.colmeia-price-pending, já nasce no
  // HTML) pra nunca trocar de valor na tela. ?ip= na URL força outro IP pra
  // teste (só funciona com a env var ligada; desligada em produção, onde
  // vale o IP real), repassado também pro draft order (cart-summary.liquid).
  // Fica salvo no sessionStorage pra continuar valendo em páginas sem ?ip=
  // na URL — só troca quando aparece outro ?ip= (ver getForcedIp).

  var FETCH_TIMEOUT_MS = 6000;
  var FORCED_IP_STORAGE_KEY = 'colmeiaForcedIp';

  function getForcedIp() {
    var fromUrl = null;
    try {
      fromUrl = new URLSearchParams(window.location.search).get('ip');
    } catch (error) {
      fromUrl = null;
    }

    if (fromUrl) {
      try {
        sessionStorage.setItem(FORCED_IP_STORAGE_KEY, fromUrl);
      } catch (error) {}
      return fromUrl;
    }

    try {
      return sessionStorage.getItem(FORCED_IP_STORAGE_KEY);
    } catch (error) {
      return null;
    }
  }

  // Cache só em memória, só nesta página (nunca sessionStorage/localStorage).
  // Evita chamada repetida quando quick-add/drawer disparam init() de novo.
  // Não persiste entre navegações de propósito: IP pode mudar de página pra página.
  var FACTOR_CACHE_TTL_MS = 5 * 60 * 1000;
  var cachedFactor = null;
  var cachedFactorAt = 0;

  function fetchFactor() {
    if (cachedFactor !== null && (Date.now() - cachedFactorAt) < FACTOR_CACHE_TTL_MS) {
      return Promise.resolve(cachedFactor);
    }

    var fetchOptions = { ip: getForcedIp() };
    if (typeof AbortController !== 'undefined') {
      var controller = new AbortController();
      setTimeout(function () { controller.abort(); }, FETCH_TIMEOUT_MS);
      fetchOptions.signal = controller.signal;
    }

    return ColmeiaSDK.b2c.priceFactor(fetchOptions)
      .then(function (response) {
        if (!response.ok) { throw new Error('HTTP ' + response.status); }
        return response.json();
      })
      .then(function (data) {
        var factor = Number(data && data.factor);
        var resolved = Number.isFinite(factor) && factor > 0 ? factor : null;

        // Só guarda em cache resultado bom; falha nunca fica em cache, pra
        // não travar a página inteira no preço nativo até o TTL passar.
        if (resolved !== null) {
          cachedFactor = resolved;
          cachedFactorAt = Date.now();
        }

        return resolved;
      })
      .catch(function (error) {
        console.warn('[ColmeiaRegionalPricing] Falha ao buscar fator de região:', error);
        return null;
      });
  }

  // toFixed(6) limpa ruído de ponto flutuante antes de decidir se
  // o preço é redondo ou vira ",90". Valores em reais, não centavos.
  //
  // Só pode ser aplicado a preço UNITÁRIO. O arredondamento ",90" não é
  // linear (fator×soma ≠ soma de fator×unitário), então linha e agregados
  // (subtotal, desconto, total) nunca passam direto por aqui — ver
  // applyFactorToPage.
  function applyFactorToUnitPrice(base, factor) {
    var x = base * factor;
    var clean = Number(x.toFixed(6));
    return Number.isInteger(clean) ? clean : Math.floor(clean) + 0.9;
  }

  function formatCurrency(amount) {
    return Number(amount || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  function getPendingBlocks() {
    return document.querySelectorAll('[data-colmeia-price-region]');
  }

  function reveal() {
    getPendingBlocks().forEach(function (block) {
      block.classList.remove('colmeia-price-pending');
    });

    // Sempre dispara, com ou sem fator resolvido — quem escuta (ex.: cupom
    // B2C em cart-summary.liquid) já sabe lidar com subtotal ainda não calculado.
    document.dispatchEvent(new CustomEvent('colmeia:regional-price-applied'));
  }

  // Carrinho pode ter duas instâncias na mesma página (drawer + página /cart),
  // então soma de linha tem que ficar restrita à instância certa.
  var CART_SCOPE_SELECTOR = 'cart-items-component, cart-drawer-component';

  function resolveCartScope(block) {
    return block.closest(CART_SCOPE_SELECTOR) || document;
  }

  // Soma dos totais de linha (unitário×fator, já arredondado em ",90", ×
  // quantidade) dentro do carrinho — é a base de todo valor agregado.
  function sumLineTotalsCents(scope) {
    var total = 0;
    scope.querySelectorAll('[data-colmeia-quantity]').forEach(function (block) {
      var computed = Number(block.dataset.colmeiaComputedCents);
      if (isFinite(computed)) { total += computed; }
    });
    return total;
  }

  // Carrinho pode ter duas instâncias na mesma página (drawer + página /cart),
  // então soma de linha tem que ficar restrita à instância certa.
  var CART_SCOPE_SELECTOR = 'cart-items-component, cart-drawer-component';

  function resolveCartScope(block) {
    return block.closest(CART_SCOPE_SELECTOR) || document;
  }

  // Soma dos totais de linha (unitário×fator, já arredondado em ",90", ×
  // quantidade) dentro do carrinho — é a base de todo valor agregado.
  function sumLineTotalsCents(scope) {
    var total = 0;
    scope.querySelectorAll('[data-colmeia-quantity]').forEach(function (block) {
      var computed = Number(block.dataset.colmeiaComputedCents);
      if (isFinite(computed)) { total += computed; }
    });
    return total;
  }

  function applyFactorToPage(factor) {
    if (!factor) { return; }

    var aggregateBlocks = [];

    getPendingBlocks().forEach(function (block) {
      if (block.hasAttribute('data-colmeia-price-aggregate')) {
        aggregateBlocks.push(block);
        return;
      }

      var baseCentsAttr = block.getAttribute('data-native-price-cents');
      if (baseCentsAttr) {
        var baseAmount = Number(baseCentsAttr) / 100;

        if (isFinite(baseAmount) && baseAmount > 0) {
          var adjustedUnit = applyFactorToUnitPrice(baseAmount, factor);
          var quantity = Number(block.getAttribute('data-colmeia-quantity')) || 1;
          var displayAmount = adjustedUnit * quantity;

          block.dataset.colmeiaComputedCents = String(Math.round(displayAmount * 100));

          var currentEl = block.querySelector('.price-current');
          if (currentEl) { currentEl.textContent = formatCurrency(displayAmount); }

          var pixEl = block.querySelector('[data-colmeia-pix-value]');
          if (pixEl) {
            var pixPercent = Number(block.getAttribute('data-pix-percent')) || 95;
            pixEl.textContent = formatCurrency(adjustedUnit * pixPercent / 100);
          }

          var installmentEl = block.querySelector('[data-colmeia-installment-value]');
          if (installmentEl) {
            var installments = Number(block.getAttribute('data-installments')) || 4;
            installmentEl.textContent = formatCurrency(adjustedUnit / installments);
          }
        }
      }

      var compareCentsAttr = block.getAttribute('data-native-compare-cents');
      var compareEl = block.querySelector('.price-compare');
      if (compareEl && compareCentsAttr) {
        var compareAmount = Number(compareCentsAttr) / 100;
        if (isFinite(compareAmount) && compareAmount > 0) {
          compareEl.textContent = formatCurrency(applyFactorToUnitPrice(compareAmount, factor));
        }
      }
    });

    // Agregado (subtotal/total do carrinho) nunca recebe o fator direto —
    // não é linear. É sempre a soma dos totais de linha já calculados acima.
    // O cupom B2C não é desconto nativo da Shopify (cart_level_discount_applications
    // fica vazio), então não existe "total menos desconto" pra calcular aqui —
    // isso é responsabilidade de quem sabe do cupom (cart-summary.liquid).
    aggregateBlocks.forEach(function (block) {
      var mode = block.getAttribute('data-colmeia-price-aggregate');
      if (mode !== 'subtotal') { return; }

      var scope = resolveCartScope(block);
      var amountCents = sumLineTotalsCents(scope);

      block.dataset.colmeiaComputedCents = String(amountCents);

      var currentEl = block.querySelector('.price-current');
      if (currentEl) { currentEl.textContent = formatCurrency(amountCents / 100); }
    });
  }

  function init() {
    // sempre revela no final, com ou sem fator
    fetchFactor()
      .then(applyFactorToPage)
      .catch(function () {})
      .then(reveal, reveal);
  }

  function fetchWithTimeout(url, ms) {
    if (typeof AbortController === 'undefined') { return fetch(url); }

    var controller = new AbortController();
    var timer = setTimeout(function () { controller.abort(); }, ms);

    return fetch(url, { signal: controller.signal }).finally(function () {
      clearTimeout(timer);
    });
  }

  function logPublicIpForDebug() {
    fetchWithTimeout('https://api.ipify.org?format=json', FETCH_TIMEOUT_MS)
      .then(function (response) {
        if (!response.ok) { throw new Error('HTTP ' + response.status); }
        return response.json();
      })
      .then(function (data) {
        console.info('[ColmeiaRegionalPricing] IP público (ipify, debug compare com o log do servidor):', data && data.ip);
      })
      .catch(function (error) {
        console.warn('[ColmeiaRegionalPricing] Falha ao buscar IP público via ipify (debug):', error);
      });
  }

  // Exposto pra quem precisa do subtotal regional já calculado sem duplicar a
  // soma (ex.: cupom B2C em cart-summary.liquid, escuta 'colmeia:regional-price-applied').
  window.ColmeiaRegionalPricing = {
    resolveCartScope: resolveCartScope,
    sumLineTotalsCents: sumLineTotalsCents,
  };

  init();

  // Só debug (loga IP público pra comparar com o log do servidor); nunca pode
  // interromper o resto do script (ver bug do fetchWithTimeout ausente que
  // travou o MutationObserver/listener abaixo em produção).
  try {
    logPublicIpForDebug();
  } catch (error) {
    console.warn('[ColmeiaRegionalPricing] logPublicIpForDebug falhou, ignorando:', error);
  }

  // Reaplica quando a Shopify re-renderiza seções (editor de temas, troca de
  // variante, etc).
  document.addEventListener('shopify:section:load', init);

  // @theme/morph injeta HTML (quick-add, etc.) sem disparar
  // shopify:section:load, então preço em conteúdo novo ficava travado no
  // nativo. Observa o DOM inteiro em vez de caçar evento por componente;
  // requestAnimationFrame agrupa rajadas de mutação numa checagem só.
  function hasPendingBlock() {
    return document.querySelector('[data-colmeia-price-region].colmeia-price-pending') !== null;
  }

  var scheduledReapply = null;

  function scheduleReapply() {
    if (scheduledReapply) { return; }

    scheduledReapply = requestAnimationFrame(function () {
      scheduledReapply = null;
      if (hasPendingBlock()) { init(); }
    });
  }

  // O morph do carrinho (troca de quantidade, remover item) atualiza o texto e
  // a classe dos preços NO LUGAR, sem adicionar nó: só childList não pega, e o
  // total do drawer ficava no valor nativo (preço cheio). Por isso também
  // observa characterData e a classe (volta o colmeia-price-pending).
  new MutationObserver(function () {
    scheduleReapply();
  }).observe(document.body, {
    childList: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['class'],
    subtree: true,
  });
})();
